import WebFont from 'webfontloader'

const GoogleFonts = () => {
  WebFont.load({
    google: {
      families: ['Nunito:400,600,700', 'Cairo:400,700,600&display=swap']
    }
  })
}

export default GoogleFonts
export const EnglishFont = 'Nunito'
export const ArabicFont = 'Cairo'
